export default {
  partOfTeam: {
    title: 'Come and be a part of #teamSIS!',
    description:
      'We have the ideal position for you. Be part of a company that welcomes employees, offers various benefits, and supports their development.',
    buttonText: 'Come and join SIS',
  },
}
